// extracted by mini-css-extract-plugin
export var arrow = "ExpandableContent-module--arrow--00b51";
export var badgeContainer = "ExpandableContent-module--badgeContainer--39222";
export var badgeImage = "ExpandableContent-module--badgeImage--aca7a";
export var badgeList = "ExpandableContent-module--badgeList--74444";
export var content = "ExpandableContent-module--content--8a2c1";
export var expandableContainer = "ExpandableContent-module--expandableContainer--321ca";
export var expanded = "ExpandableContent-module--expanded--daefe";
export var firstSection = "ExpandableContent-module--firstSection--4b540";
export var firstSectionContent = "ExpandableContent-module--firstSectionContent--2a471";
export var firstSectionTitle = "ExpandableContent-module--firstSectionTitle--92fc7";
export var header = "ExpandableContent-module--header--75583";
export var mainTitle = "ExpandableContent-module--mainTitle--aa353";
export var section = "ExpandableContent-module--section--89642";
export var sectionList = "ExpandableContent-module--sectionList--97cda";
export var sectionTitle = "ExpandableContent-module--sectionTitle--c1b8d";
export var shareSectionWrapper = "ExpandableContent-module--shareSectionWrapper--c9ca1";
export var wordList = "ExpandableContent-module--wordList--5e1fa";